var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { TableCell, TableHead, TableRow } from '../../../common';
export var RoleTableHeader = function (_a) {
    var disableSupportStaff = _a.disableSupportStaff, disableFinancial = _a.disableFinancial, isReview = _a.isReview;
    var t = useTranslation('wizard').t;
    return (_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, __assign({ align: "left" }, { children: t('supportStaff.role') })), !disableSupportStaff && _jsx(TableCell, { children: t('supportStaff.roleAppliesTo') }), !disableSupportStaff && _jsx(TableCell, { children: t('supportStaff.ratioStaffToAgents') }), !disableSupportStaff && _jsx(TableCell, { children: t('supportStaff.staffBaseOn') }), !disableFinancial && _jsx(TableCell, __assign({ sx: { minWidth: '10rem' } }, { children: t('financial.wageType') })), !disableFinancial && _jsx(TableCell, { children: t('financial.amount') }), !disableFinancial && _jsx(TableCell, { children: t('financial.loadFactor') }), !disableSupportStaff && !isReview && _jsx(TableCell, { sx: { width: '3rem' } })] }) }));
};
